import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import UserService from '../../../Services/userService';
import OfficeHelper from '../../../Helpers/ModelHelpers/OfficeHelper';

export default class ProjectSearchParams extends SearchParamsBase {
  constructor(clientId) {
    super();
    if (clientId !== undefined) {
      this.ClientId = clientId.toString();
    }
  }

  initialize() {
    this.ProjectIdOrName = '';
    this.ClientIdOrName = '';
    this.OfficeName = OfficeHelper.GetDefaultOfficeIds(UserService.GetOfficeIdOfLoggedInUser());
    this.ProjectManagerNameOrId = '';
    this.OpportunityNameOrId = '';
    this.ServiceNameOrId = '';
    this.UseProjectDateRange = false;
    this.ProjectStartDate = dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.indefiniteDateValue());
    this.ProjectEndDate = dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.indefiniteDateValue());
    this.IsActive = '';
    this.ClientId = '';
  }

  static fieldsInSearchBox = [
    { fieldName: 'ProjectIdOrName', label: 'Project ID or Name', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'ClientIdOrName', label: 'Client ID or Name', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'OfficeName', label: 'Office', className: 'col-4', type: InputTypesEnum.OfficeOrGroupSelect },
    { fieldName: 'ProjectManagerNameOrId', label: 'Project Manager', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'OpportunityNameOrId', label: 'Opportunity', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'ServiceNameOrId', label: 'Service', className: 'col-4', type: InputTypesEnum.Text },
    {
      fieldName: 'UseProjectDateRange',
      label: 'Use Project Date Range',
      className: 'col-4',
      type: InputTypesEnum.OnOff,
    },
    {
      fieldName: 'ProjectStartDate',
      label: 'Project Start Date',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseProjectDateRange,
    },
    {
      fieldName: 'ProjectEndDate',
      label: 'Project End Date',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseProjectDateRange,
    },
    { fieldName: 'IsActive', label: 'Is Active?', className: 'col-4', type: InputTypesEnum.EmptyYesNoSelect },
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'ProjectSearchParams';
}
